import moment from "moment";
import { UserInfos } from "../../../../../redux/types";

function TabsInfoPerso({ state }: { state: UserInfos }) {
  const DATA = [
    {
      libelle: "Nom",
      value: `${state?.prenom} ${state?.nom}`,
    },
    {
      libelle: "Entreprise",
      value: state?.entreprise || "Non renseigné",
    },
    {
      libelle: "Email Entreprise",
      value: state?.email,
    },
    {
      libelle: "Email Comptable",
      value: state?.email_comptable || "Non renseigné",
    },
    {
      libelle: "Date inscription client",
      value: moment(state.created_at).format("DD/MM/YYYY"),
    },
    {
      libelle: "Téléphone",
      value: state?.telephone || "Non renseigné",
    },
    {
      libelle: "N° RNA",
      value: state?.rna || "Non renseigné",
    },
    {
      libelle: state.type_siret || "N° SIREN / N° SIRET",
      value: state?.siret || "Non renseigné",
    },
  ];

  return (
    <div className="bg-white p-3 filter-and-table-container">
      {DATA.map((item) => {
        return (
          <div className="row row-info-perso-user">
            <div className="col-md-6">
              <div className="content-text-info-user">
                <p className="text-info-user-libelle">{item.libelle}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="content-text-info-user">
                <p className="text-info-user-value">{item.value}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TabsInfoPerso;
